import { IconButton, InputAdornment, TextField } from '@mui/material'
import { useState } from 'react'
import PersonIcon from '@mui/icons-material/Person';

import { ErrorOutlineOutlined } from '@mui/icons-material'
import { colors } from '../../constants/colors'
import HelperText from './helperText'
import { styled } from '@mui/material/styles'

const CustomTextField = styled(TextField)<{ inputHeight?: any }>(({ theme, inputHeight }) => ({
  width: '100%',
  '.MuiOutlinedInput-root': {
    height: inputHeight || 43,
    borderRadius: 8,
    '.MuiOutlinedInput-notchedOutline, &.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      top : '-5px !important',
      borderColor: `${colors.black_12}`
    },
    '&:hover': {
      // borderColor: `${colors.black_12}`,
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${colors.themeMainColor}`
      }
    },
    '&.Mui-focused fieldset': {
      borderColor: `${colors.themeMainColor}`,
    },
    '&.Mui-error': {
      '.MuiOutlinedInput-notchedOutline': {
        border: `2px solid ${colors.statusInactiveColor} !important`
      }
    }
  },
  '.MuiInputLabel-root, .MuiInputLabel-root span': {
    fontSize: 16,
    color: `${colors.black_60} !important`,
    '&.MuiInputLabel-root': {
      paddingLeft: 1
    },
    backgroundColor: 'transparent !important',
    '&:before': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: 3,
      top: '50.5%',
      zIndex: -1
    },
    '&[data-shrink="true"]': {
      '&.Mui-focused': {
        color: `${colors.themeMainColor} !important`
      },
      '&:before': {
        backgroundColor: colors.white
      },
      span: {
        color: `${colors.statusInactiveColor} !important`
      }
    }
  },
  '.MuiOutlinedInput-input': {
    height: inputHeight || 43,
    fontSize: 16,
    color: `${colors.textPrimary} !important`,
    '-webkit-text-fill-color': 'unset !important',
    padding: '0 1rem',
    '&.Mui-disabled': {
      color: `${colors.black_60} !important`
    }
  },
  '&.filed-error': {
    '.MuiInputLabel-root[data-shrink="true"], .MuiInputLabel-root[data-shrink="true"] span': {
      color: `${colors.statusInactiveColor} !important`
    }
  },
  '&.hide-control': {
    'input[type=number], input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'none',
      appearance: 'none'
    }
  }
}))

type InputProps = {
  onchange?: (value: any) => void
  onkeyup?: (value: any) => void
  required?: boolean
  disabled?: boolean
  variant?: any
  size?: 'medium' | 'small'
  label?: string
  type?: string
  name?: string
  helperText?: string
  value?: string
  inputProps?: any
  heading?: string
  headingAlign?: string
}
export default function InputUsernameField(props: InputProps) {
  // const classes = useStyles()

  return (
    <div>
      {props.heading &&
        <div className='pb-2' style={{textAlign : 'left' || props.headingAlign}}>
          {props.heading}
        </div>
      }
      <CustomTextField
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              
                <PersonIcon/>

            </InputAdornment>
          ),
          ...props.inputProps
        }}
        className={`${props.helperText ? 'filed-error' : ''}`}
        onChange={props.onchange}
        onKeyUp={props.onkeyup}
        variant={props.variant || 'outlined'}
        size={props.size || 'small'}
        required={props.required}
        label={props.label}
        disabled={props.disabled}
        name={props.name}
        value={props?.value || undefined}
        type={'text'}
        error={props.helperText !== ''}
        helperText={
          props.helperText ? (
            <HelperText label={props.helperText} />
          ) : (
            ''
          )
        }
      />
    </div>
  )
}
